import React, { useRef, useState } from "react";
import "./mainPage.css"; // Create a corresponding CSS file for styles
import { useNavigate } from "react-router-dom";
import {
  COUPON_ITEM_KEY,
  customerFrustrationArray,
  SAVE_ITEM_KEY,
} from "./constants";
import { FormButton } from "./components/formButton";

export const paymentLinks = {
  app: `https://buy.stripe.com/aEU5le0em50F3OE28f`,
  device:`https://buy.stripe.com/dR69BuaT02Sx4SI9AN`,
  esa: `https://newlessonplan.com/kit-details/t6bvinbCZr0uhFdsdLbU/third`,
  amazon: `https://www.amazon.com/dp/B0DR6HVSF9?ref=cm_sw_r_cp_ud_dp_5958DJ3S6NMKMBKZ7C3Y_1&ref_=cm_sw_r_cp_ud_dp_5958DJ3S6NMKMBKZ7C3Y_1&social_share=cm_sw_r_cp_ud_dp_5958DJ3S6NMKMBKZ7C3Y_1&skipTwisterOG=1`
}

const MAIN_COLOR = '#539DF6'

export const buying_options = [
  // {
  //   title: 'Buy Just The App',
  //   description: "If you prefer to use your own device/pad, this option is for you. Will give you a link to download the app and activation code to own it forever. No subscriptions. All updates are free.",
  //   price: '$150',
  //   link: paymentLinks.app
  // },
  {
    title: 'Buy on Amazon',
    description: "Click me to go to Amazon listing",
   // price: '$150',
    link: paymentLinks.amazon,
    isPopular: true,
    buttonText: 'Buy on Amazon'
  },
  {
    title: 'Pay with Card',
    description: "Receive a ready-to-use TalkingIris AAC tablet—turn it on and share the joy with your child!",
    price: '$300',
    link: paymentLinks.device,
    buttonText: 'Buy Now'
  },
  {
    title: 'Buy With ESA Funds',
    description: "If you want to use your ESA funds, we partner with NewLessonPlan to make it happen.",
   // price: '$150',
    link: paymentLinks.esa,
    isEsa: true,
    buttonText: 'Buy with ESA'
  },
]


export const Home = ({ onOk = () => {} }) => {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [imageSrc, setImageSrc] = React.useState(
    windowWidth >= 768
      ? require("./assets/images/desktop_header.png")
      : require("./assets/images/mobile.png")
  );

  React.useEffect(() => {
    const handleResize = () => {
      console.log("ksl" + window.innerWidth >= 768);
      setImageSrc(
        window.innerWidth >= 768
          ? require("./assets/images/desktop_header.png")
          : require("./assets/images/mobile.png")
      );
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  React.useEffect(() => {
    sessionStorage.removeItem(SAVE_ITEM_KEY);
    sessionStorage.removeItem(COUPON_ITEM_KEY);
  }, []);

  return (
    <div className="bg-white">
    <div className="relative isolate px-6 pt-14 lg:px-8">
      <MainBg />

      <div className="mx-auto max-w-2xl mt-10 mb-20">
        <div className="text-center">
          <h1
            className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl leading-loose"
            style={{ lineHeight: 1.2 }}
          >
            Their Eyes Always Spoke,  
            <div className="text-[#6699ff]">Now You Can Hear Them</div> 
          </h1>



          <h2 className="mt-10 text-gray-500 text-transparent">
          Affordable Eye and Touch Speech Tablet (AAC) for Nonverbal Adults


          </h2>

         
          <div className="pt-10 pt-1   leading-[1.7] text-2xl  p-10 rounded text-left ">
          Your loved one’s mind is still sharp — but their words are trapped inside.

          <div className="mt-3" />
         
          Watching them struggle to speak is heartbreaking.
          
        
        </div>



        <div className="">
          <img src={require("./assets/images/nonverbal_adult_speech_tablet.png")} alt="Talking Iris AAC Device"
        
          />
           
          </div>

          <div className="mt-20 pt-10 mt-10 fs-3 leading-[1.7] bg-yellow-200 p-10 rounded">
          Imagine them sharing their thoughts and feelings with ease.


            </div>

 <div className="mt-10">
          <img src={require("./assets/images/s.png")} alt="Talking Iris AAC Device"
          className="rounded-[60px] border-[10px]"
          
          />
           
          </div>
  <div className="mt-20 pt-10 mt-10 fs-3 leading-[1.7] bg-blue-200 p-10 rounded">
          Talking Iris gives nonverbal adults their voice back — with eyes, hands, or a caregiver’s gentle touch.


            </div>
            <VideoComponent isDemo/>

            <div className="mt-20">
            <div className="pt-10 mt-10 text-left fs-5 leading-[1.7] bg-gray-100 p-10 rounded ">
           
Talking Iris is a specialized AAC (Augmentative and Alternative Communication) tablet designed to restore communication for nonverbal adults.



        </div>
           
          </div>
          <div className="text-center m-10" aria-hidden="true">
          <img src={require("./assets/images/eye_tracking_aac_ALS_STROKE_MS.png")} alt="Additional Device Features" className="rounded-[100px]   " />
        </div>
      
  <div className="p-10 text-center bg-yellow-100 m-10 text-2xl fw-bold">
    Let TalkingIris empower your loved one to express themselves effortlessly.
    </div>



    <div className="mb-20"/>
    
         

        


          <div className="pt-10 mt-10 fs-5  p-10 rounded
           bg-green-300
        ">
          
          <h1
            className="text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl leading-loose mb-4"
            style={{ lineHeight: 1.2 }}
          >
            <div className="text-success">Flexible Through Every Stage</div>
          </h1>
          <FeaturesList
  arr={[
    "Eye Gaze or Touch Control",
    "Big, Easy-to-Press Tiles",
    "Caregiver Tap Support",
    "Custom Images and Voices",
    "5,000+ Preloaded Phrases",
    "No $7,000 Insurance Hassles",
    "Large 11\" Display",
    "Long Battery Life"
  ]}
/>


        </div>


  <div className="text-center m-10" aria-hidden="true">
          <img src={require("./assets/images/AAC_nonverbal_bedridden_stand.png")} alt="Additional Device Features" className="rounded-[100px]   " />
        </div>
        <div class="max-w-3xl mx-auto mt-6 text-center">
            <div class="bg-yellow-200 p-6 rounded-xl shadow-lg">
            <h3 class="text-3xl font-bold text-center mb-10">What's in the box?</h3>
            <FeaturesList
            arr={[
             `Talking Iris AAC 11" Tablet`,
             "Manual",
             "Rotatable stand",
             "Wall charger + cable",
            ]}
          />
             </div>
           
        </div>

    
        
        </div>

     

       

     
        <div className="font-medium text-gray-700 mb-1 mt-10" id="buy-now"></div>
  <div className="w-100 text-center d-flex">
   
   
    <BuyOnAmazonButton />
   
    <div className="p-2" />
    <BuyWithCard/>
   
  </div>

  {/* eBay Option - Clearly for European Buyers */}
  
  <div className="w-100 tex-center mt-10">
   
    <BuyOnEbayButton />
    <div className="font-medium text-gray-700 mb-2 text-center">For 🇬🇧🇪🇺 UK/Europe</div>
  </div>

</div>

<div className="d-flex flex-column gap-6 align-items-center w-100 ">
  
  {/* Primary Purchase Option - Bigger & More Prominent */}
 

  {/* Alternative Option - Amazon */}

  <div className="font-medium text-gray-700 mb-1"></div>
  <div className="w-100 text-center d-flex">
   
   
  {1==1 ? null :   <BuyOnAmazonButton />}
   
 

  {/* eBay Option - Clearly for European Buyers */}
  
 {1==1 ? null :  <div className="w-100 tex-center mt-10">
   
    <BuyOnEbayButton />
    <div className="font-medium text-gray-700 mb-2 text-center">For 🇬🇧🇪🇺 UK/Europe</div>
  </div>}

</div>



       

        <div className="pt-10 mt-10  p-10 rounded-lg  flex items-center flex-col">
             
              <h2 className="text-2xl font-bold mb-4">Same day handling. Get it <strong>in 2 business days.</strong></h2>
              
              {/* <p className="text-lg mt-4">Use code <span className="text-yellow-300 font-bold">"TILES10"</span> at checkout to save <strong>10% on your order</strong>.</p> */}
            </div>

      </div>

      <p className="mt-6 text-lg leading-8 text-gray-600 text-center"></p>
      <div
        className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
        aria-hidden="true"
      >
        <div
          className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff9d80] via-[#ff80b5] to-[#6699ff] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
          style={{
            clipPath:
              "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
          }}
        />
      </div>
    </div>
  </div>



  );

  return (
    <>
      <div className={windowWidth > 768 ? `text-center m-20` : ""}>
        <img src={imageSrc} alt="" className="header-image rounded" />

        <div style={{ margin: "0 auto", maxWidth: "80%" }}>
          <div
            className="btn-info w-100 mt-10 px-10 py-3 cursor-pointer text-center fs-4"
            onClick={() => (document.location.href = "/new")}
          >
            Create Your Curriculum
          </div>

          <div className="col-sm-12 text-center mt-10">
            <small></small>
          </div>
        </div>
      </div>
    </>
  );
};

export const MainBg = () => {
  return (
    <div
      className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
      aria-hidden="true"
      style={{ pointerEvents: "none" }}
    >
      <div
        className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
        style={{
          clipPath:
            "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
        }}
      />
    </div>
  );
};
export const MainHeader = () => {
  return (
    <header className="absolute inset-x-0 top-0 z-50">
      <nav
        className="flex items-center justify-between p-6 lg:px-8"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <a href="#" className="-m-1.5 p-1.5">
            <span className="sr-only">Your Company</span>
            <img
              className="h-8 w-auto"
              src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600"
              alt=""
            />
          </a>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-12">
          <a href="#" className="text-sm font-semibold leading-6 text-gray-900">
            Product
          </a>
          <a href="#" className="text-sm font-semibold leading-6 text-gray-900">
            Features
          </a>
          <a href="#" className="text-sm font-semibold leading-6 text-gray-900">
            Marketplace
          </a>
          <a href="#" className="text-sm font-semibold leading-6 text-gray-900">
            Company
          </a>
        </div>
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <a href="#" className="text-sm font-semibold leading-6 text-gray-900">
            Log in <span aria-hidden="true">→</span>
          </a>
        </div>
      </nav>
      {/* Mobile menu, show/hide based on menu open state. */}
      <div className="lg:hidden" role="dialog" aria-modal="true">
        {/* Background backdrop, show/hide based on slide-over state. */}
        <div className="fixed inset-0 z-50" />
        <div className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <a href="#" className="-m-1.5 p-1.5">
              <span className="sr-only">Your Company</span>
              <img
                className="h-8 w-auto"
                src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600"
                alt=""
              />
            </a>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
            >
              <span className="sr-only">Close menu</span>
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                <a
                  href="#"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Product
                </a>
                <a
                  href="#"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Features
                </a>
                <a
                  href="#"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Marketplace
                </a>
                <a
                  href="#"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Company
                </a>
              </div>
              <div className="py-6">
                <a
                  href="#"
                  className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Log in
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export const FeaturesList = ({ arr = [] }) => {
  return (
    <div>
      <ul className="list-disc space-y-5 mt-1 text-left">
        {arr?.map((feat) => (
          <div class="d-flex align-items-center mb-2">
            <i class="bi bi-check text-success fs-4 "></i>
            <span>{feat}</span>
          </div>
        ))}
      </ul>
    </div>
  );
};



const HomeTile = ({
  features = [],
  title = "",
  iconName = "",
  bgColor = "",
  destination = "",
  buttonTitle = "",
  btnColor = "",
  extraFeatures = [],
  className = ''
}) => {
  return (
    <div
      class={`${className} rounded-lg p-6 shadow-md text-center md:hover:scale-125 hover:shadow-xl cursor-pointer transition flex flex-col justify-between h-full group`}
    >
      <div class="text-center mt-2">
        <div class={`text-${btnColor} text-4xl mb-4`}>
          <i class={`bi bi-${iconName}`}></i>
        </div>
        <h3 class="text-xl font-semibold text-gray-800 mb-4">{title}</h3>
        {/* Default Features */}
        <div class="md:group-hover:hidden">
          <FeaturesList arr={features} />
        </div>
        {/* Extra Features (Visible on Hover) */}
        <div class="hidden md:group-hover:block">
          <FeaturesList arr={extraFeatures?.length ? extraFeatures  : features} />
        </div>
      </div>
      <FormButton
        isPrimary
        isFullWidth hoverColor={`bg-${btnColor}`}
        superExtraClass={`mt-10 hover:scale-110 hover:shadow-xl bg-${btnColor} hover:bg-${btnColor} p-3 text-xl`}
        label={buttonTitle}
        onClick={() => (window.location.href = destination)}
      />
    </div>
  );
};



const VideoComponent = ({ isDemo ,isUnboxing}) => {
  const videoRef = useRef(null); // Reference to the video element
  const [isVideoPlaying, setIsVideoPlaying] = useState(false); // State to toggle between image and video

  const handlePlayClick = () => {
    setIsVideoPlaying(true); // Show the video
    if (videoRef.current) {
      videoRef.current.muted = false; // Unmute the video
      videoRef.current.play(); // Play the video
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "60px", position: "relative" }}>
      {isVideoPlaying || isDemo ? (
        // Render video when play is clicked
        <video
          ref={videoRef}
          className={isDemo && !isUnboxing ? 'w-100' :  "mx-auto w-100"}
          autoPlay
          loop
          playsInline
          controls={!isDemo}
          muted={isDemo}
          style={{
            margin: "0 auto",
            borderRadius: "20px",
            borderColor: "indigo",
            borderWidth: 5,
          }}
        >
          <source
            src={
              isUnboxing? require('./assets/images/talking-iris-eye-gaze-aac.mp4') : 
              isDemo ? 
              require("./assets/images/talking-iris-eye-gaze-aac.mp4") : 
              
              require("./assets/images/talking-iris-eye-gaze-aac.mp4")}

            type="video/mp4"
          />
        </video>
      ) : (
        // Render image with play button
        <div className="shadow-xl rounded-[20px]" style={{ position: "relative", display: "inline-block" }}>
          <img
            src={
              require("./assets/images/video_thumbnail.png")}
            alt="Video Thumbnail"
            style={{
              borderRadius: "12px",
              maxWidth: "100%",
              cursor: "pointer",
              borderColor: MAIN_COLOR,
              borderWidth: 6
            }}
          />
          <button
          className="shadow"
            onClick={handlePlayClick}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
              background:  'black',
              border: "none",
              color: "white",
              fontSize: "60px",
              borderRadius: "50%",
              width: "100px",
              height: "100px",
              cursor: "pointer",
              
            }}
          >
            <div className="bi bi-play"></div>
          </button>
        </div>
      )}
    </div>
  );
};

export default VideoComponent;


const BaseButton = ({url = '', bg= 'bg-[#FF9900]', text = 'Buy on Amazon', imageOrIcon }) => {
  return (
    <a
    className={`w-100 text-center text-white rounded-md py-3 text-lg font-bold cursor-pointer shadow-md hover:shadow-lg hover:scale-110 transition flex items-center justify-center ${bg}`}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
     
    >
  
     <div className="">
  <div className="flex items-center justify-center">
   {imageOrIcon || <div className="bi bi-amazon mx-2 text-xl"></div>}
    <div className="text-xl">{text}</div>
  </div>
</div>

    </a>
  );

}


const BuyOnAmazonButton = ({ url = 'https://www.amazon.com/dp/B0F31LR821' }) => {
  return (<BaseButton url={url} />
   
  );
};

const BuyWithCard = ({url = buying_options[1].link }) => {

  return (<BaseButton url={url} text="Pay with Card" bg="bg-purple-500"
    imageOrIcon={ <div className="bi bi-credit-card mx-2 text-xl"></div>}
    />)
  
};


const BuyOnEbayButton = ({ url = 'https://www.ebay.com/itm/306328350075' }) => {
  return (<BaseButton url={url} text="Buy on e-Bay" bg="bg-black"
    imageOrIcon={<img src={require('./assets/images/ebay_logo.png')} className="h-8" />}
    />)
 
};
